module.exports = __webpack_public_path__ + "img/telephone.6da4177c.svg";